// extracted by mini-css-extract-plugin
export default {"rowLabel":"Custom_rowLabel__1V-N-","text":"Custom_text__Oetfi"};